var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.showSnackbar,"color":_vm.snackbarColor,"bottom":"","left":!_vm.$vuetify.breakpoint.mobile},on:{"input":function($event){return _vm.getSnackbarValue($event)}}},[_vm._v(" "+_vm._s(_vm.snackbarMessage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }